import { render, staticRenderFns } from "./FeAbel.vue?vue&type=template&id=70bb403c&"
import script from "./FeAbel.vue?vue&type=script&lang=js&"
export * from "./FeAbel.vue?vue&type=script&lang=js&"
import style0 from "./FeAbel.vue?vue&type=style&index=0&id=70bb403c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports